export default "__VITE_ASSET__CEfPw2EJ__"